import { IconButton, Modal, Tooltip } from '@mui/material';
import { ArrowDropDown, Close } from '@mui/icons-material';
import { Col, Input, Row, Select, Space } from "antd";
import Loading from "components/Loading";
import { get, uniqueId } from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { handleCreateWorksheet, handleLearningModuleCount } from "store/bingo/thunks";
import { useCurrentClass } from "store/classes/selectors";
import { useCurrentUser } from "store/users/selectors";
import { useWorkSheetSelector } from "store/worksheet/selectors";
import {
  handleListQuestionOfWorksheet,
  handleListWorkSheet,
  handleSaveQuestionBank,
  handleSaveTeachersQuestion,
} from "store/worksheet/thunks";
import { setWorksheetView } from "store/worksheetView/action";
import styled from "styled-components";
import { getRandomImage } from "utils/config/reference";
import CloseIconss from "../../../utils/assets/images/closes.svg";
import {
  getLabels,
  getLabelsCategory,
  lengthOptionsForTeachers,
  lengthOptions,
  moodsOption,
  pronounOptions,
  question_type_generate_more_worksheet,
} from "../helper";
import GenerateLoader from "./generateLoader";
import SelectQaOption from "./selectQaOption";
import { useAllBook } from "store/books/selectors";
import { useResources, useVideos } from "store/resources/selectors";
import { getBookDisplayName } from "utils/lib/ebookHelper";
import { useClassGameActivity } from "store/one_game/selectors";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { handleStreamResponse } from 'utils/methods/QuestionCreateStreamHandle';
import AIUsageInfo from 'components/Modals/AiInfoModal';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import SentryWrap from 'components/Sentry';

const ValidationMessageWithTooltip = ({ label, text }) => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
  
  const tooltipTitle = label === "Pronouns" 
    ? "All pronouns have to be selected." 
    : "All question types have to be selected.";

  const validationMessage = (
    <ValidationMessage>
      {text}
    </ValidationMessage>
  );

  return isMobile ? (
    <Tooltip title={tooltipTitle}>
      {validationMessage}
    </Tooltip>
  ) : (
    validationMessage
  );
};

export default function TeachersWorkSheet({
  isOpen = false,
  setIsOpen,
  book_id,
  page_id,
  numberMasked,
}) {
  const showAlert = useAlert();
  const [selectedOption, setSelectedOption] = useState(1);
  const [dropdownVisibility, setDropdownVisibility] = useState({
    mood: false,
    tenses: false,
    categories: false,
    pronouns: false,
    questionType: false,
    questionLength: false,
  });
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const currentClass = useCurrentClass();

  const [title, setTitle] = useState("");
  const [tenses, setTenses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [pronouns, setPronouns] = useState([]);
  const [mood, setMoods] = useState(null);
  const [questionLength, setQuestionLength] = useState(null);
  const [image, setImage] = useState("");
  const smileIcon = "";
  const [loader, setLoader] = useState({ type: "generate", value: false });
  const [creeateLoader, setCreeateLoader] = useState(false);
  const [questionType, setQuestionType] = useState(() =>
    question_type_generate_more_worksheet.map((option) => option.value)
  );
  const [qnaData, setQnaData] = useState({ questions:[]});
  const [openSelectQaOption, setOpenSelectQaOption] = useState(false);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const listWorkSheet = useWorkSheetSelector();
  const booksAllList = useAllBook();
  const videos = useVideos();
  const [questionCount,setQuestionCount] = useState(0)
  const resources = useResources();
  const is_super_admin = useMemo(()=>currentUser?.role === "owe_admin",[currentUser])
  const NUMBER_OF_QUESTION_OPTION = is_super_admin?lengthOptions:lengthOptionsForTeachers
  const GetBookName = getBookDisplayName(
    booksAllList,
    book_id,
    true,
    videos,
    resources
  );
  const { class_game_activity } = useClassGameActivity();
  const {updatePopUpAtOnce} = usePopUpAtOnce();

  const filterListWorksheet = useMemo(() => {
    const data = listWorkSheet?.filter((item) => item?.page_id == page_id && item?.book_id == book_id);
    return data;
  }, [listWorkSheet, page_id, book_id]);

  const worksheetInfo = useMemo(() => {
    const wInfo = filterListWorksheet.find((k) => k.id == selectedOption);
    return wInfo;
  }, [filterListWorksheet, selectedOption]);

  const assignmentInfo = useMemo(() => {
    if (
      worksheetInfo &&
      worksheetInfo.id &&
      Array.isArray(class_game_activity) &&
      class_game_activity.length > 0
    ) {
      const activity = class_game_activity.find(
        (k) => k.game_id == worksheetInfo.id && k.classId == currentClass.id
      );
      if (activity) return activity;
      return {};
    }
    return {};
  }, [currentClass, worksheetInfo, class_game_activity]);

  useEffect(() => {
    if (isOpen === true) {
      handleClose(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if(isOpen){
      setTitle(`Grammar Drill - ${filterListWorksheet?.length + 1}`);
      if (currentUser?.role !== "owe_admin") {
        setPronouns(pronounOptions.map((option) => option.value));
      }
    }
  }, [isOpen]);

  const getTenseOptionData = useMemo(() => {
    const moodSelected = getLabels(mood, moodsOption)?.toString();
    const filteredData = moodsOption?.find((x) => x?.label === moodSelected);
    const getTenseoption = filteredData?.tenseOptions;
    return getTenseoption || [];
  }, [mood]);

  const getCategoryOption = useMemo(() => {
    const tenseSelected = getLabels(tenses, getTenseOptionData)?.toString();
    const filteredData = getTenseOptionData?.find(
      (x) => x?.label === tenseSelected
    );
    const getCategoryOption = filteredData?.categoryOptions;
    return getCategoryOption || [];
  }, [tenses, getTenseOptionData]);

  const adminValidation = useMemo(() => {
    const moodSelected = getLabels(mood, moodsOption)?.toString();
    if (moodSelected === "Imperative") {
      if (
        mood?.length === 0 ||
        categories?.length === 0 ||
        pronouns?.length === 0 ||
        questionType?.length === 0 ||
        questionLength === null
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        mood?.length === 0 ||
        tenses?.length === 0 ||
        categories?.length === 0 ||
        pronouns?.length === 0 ||
        questionType?.length === 0 ||
        questionLength === null
      ) {
        return true;
      } else {
        return false;
      }
    }
  }, [tenses, categories, pronouns, questionType, questionLength, mood]);

  const checkValidation = useMemo(() => {
    const moodSelected = getLabels(mood, moodsOption)?.toString();
    if (moodSelected === "Imperative") {
      if (
        title === "" ||
        categories?.length === 0 ||
        pronouns?.length === 0 ||
        questionType?.length === 0 ||
        questionLength === null
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        title === "" ||
        tenses?.length === 0 ||
        categories?.length === 0 ||
        pronouns?.length === 0 ||
        questionType?.length === 0 ||
        questionLength === null
      ) {
        return true;
      } else {
        return false;
      }
    }
  }, [title, tenses, categories, pronouns, questionType, questionLength, mood]);

  useEffect(() => {
    if (questionType?.length > 0) {
      setSelectedTypes(questionType);
    }
  }, []);

  useEffect(() => {
    setImage(getRandomImage());
  }, [isOpen]);

  const handleGenerate = async () => {
    if (checkValidation && currentUser?.role !== "owe_admin") {
      showAlert("Please fill all the fields", "error");
      return;
    } else if (adminValidation && is_super_admin) {
      showAlert("Please fill all the fields", "error");
      return;
    }
    try {
      if (is_super_admin) {
        setIsOpen(false);
        setLoader({ type: "generate", value: true });
      } else {
        setCreeateLoader(true);
      }
      const config = {
        mood: getLabels(mood, moodsOption)?.toString(),
        tense: getLabels(tenses, getTenseOptionData)?.toString(),
        categories: getLabelsCategory(categories, getCategoryOption),
        pronouns: getLabelsCategory(pronouns, pronounOptions),
        questionLength: questionLength
          ? NUMBER_OF_QUESTION_OPTION.find((opt) => opt.value === questionLength)?.label
          : null,
        questionType: question_type_generate_more_worksheet
          ?.filter((opt) => questionType.includes(opt.value))
          ?.map((element) => element.main),
      };
      const worksheetData = {
        display_name: title,
        user_id: get(currentUser, "id", ""),
        class_id: get(currentClass, "id", ""),
        book_id,
        page_id,
        config,
        role: get(currentUser, "role", ""),
      };
      let auestion_start_loading = false
      setQnaData(props => ({ ...props, config, questions: []}))
      setQuestionCount(0)
      if (is_super_admin) {
       await  handleStreamResponse({
          path: "ai/generate-worksheet-questions-threaded",
          body: JSON.stringify(worksheetData),
          onTitle: (title) => {
          },
          onQuestion: (ques) => {
             setQuestionCount(p=>p+1)
            if (!auestion_start_loading) {
              auestion_start_loading = true
              setLoader({ type: "generate", value: false });
              setOpenSelectQaOption(true);
            }
            setQnaData(props => ({ ...props, questions: [...props.questions, { ...ques, id: uniqueId() }] }))
          },
          onDone: () => {
            setQuestionCount(0)
            setLoader({ type: "generate", value: false });
          },
          onError: () => {
             setQuestionCount(0)
            showAlert("Something went wrong, please try again!", "error");
            setLoader({ type: "generate", value: false });
            return;
          }
        })
      } else {
        const { data } = await handleSaveTeachersQuestion({ worksheetData });
        if (data?.id) {
          const response = await dispatch(
            handleListQuestionOfWorksheet(data?.id)
          );
          let questionArray = [];
          if (Array.isArray(response)) {
            response.forEach((element) => {
              const questionData = {
                ...element?.question,
                image: element?.image,
                answer_audio: element?.answer_audio,
                question_audio: element?.question_audio,
              };
              questionArray.push(questionData);
            });
            await dispatch(
              setWorksheetView({
                open: true,
                questions: questionArray,
                title: title,
                GetBookName: GetBookName,
                bookId: numberMasked,
                assignmentInfo: assignmentInfo,
              })
            );
            await dispatch(
              handleListWorkSheet(book_id, currentUser?.role, currentUser?.id, null, null, null, null, currentClass?.id)
            );
            showAlert(
              "Please review questions and close before assigning.",
              "info",
              true
            );
            dispatch(handleLearningModuleCount({
              chapter: book_id,
              userId: currentUser?.id,
              pageId: page_id,
            }));
          }
          setIsOpen(false);
        } else {
          showAlert(
            "Questions for these configurations will be available soon. Please try modifying your selections in the meantime.",
            "error"
          );
        }
        setCreeateLoader(false);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // Reordering the options based on selectedValues
  const reorderOptions = (options, selectedValues) => {
    const validSelectedValues = Array.isArray(selectedValues)
      ? selectedValues
      : [];
    const selectedOptions = options.filter((opt) =>
      validSelectedValues.includes(opt.value)
    );
    const unselectedOptions = options.filter(
      (opt) => !validSelectedValues.includes(opt.value)
    );
    return [...selectedOptions, ...unselectedOptions];
  };

  const handleGenerateMoreQna = async (questionLengthValue) => {
    try {
      setLoader({ type: "generateMore", value: true });
      const tempQnaData = { ...qnaData };

      const questionTypesToUse =
        selectedTypes.length > 0
          ? selectedTypes
          : question_type_generate_more_worksheet.map((opt) => opt.value);
      tempQnaData.config.questionType = question_type_generate_more_worksheet
        ?.filter((opt) => questionTypesToUse.includes(opt.main))
        ?.map((element) => element.main);

      if (questionLengthValue) {
        tempQnaData.config.questionLength = questionLengthValue;
      }
      let init_loader=false;
       setQuestionCount(0)
      await handleStreamResponse({
        path: "ai/generate-worksheet-questions-threaded",
        body: JSON.stringify({
          display_name: title,
          user_id: get(currentUser, "id", ""),
          class_id: get(currentClass, "id", ""),
          book_id,
          page_id,
          role: get(currentUser, "role", ""),
          config: tempQnaData?.config
        }),
        onTitle: (title) => {
        },
        onQuestion: (ques) => {
          if (!init_loader) {
            init_loader = true;
            setLoader({ type: "generateMore", value: false });
          }
          setQuestionCount(p=>p+1)
          setQnaData(props => ({ ...props, questions: [...props.questions, { ...ques, id: uniqueId() }] }))
        },
        onDone: () => {
           setLoader({ type: "generateMore", value: false });
           setQuestionCount(0)
          showAlert("Questions generated successfully!", "success");
        },
        onError: () => {
          setQuestionCount(0)
          showAlert("Something went wrong, please try again!", "error");
          setLoader({ type: "generateMore", value: false });
          return;
        }
      })
    } catch (error) {
      setLoader({ type: "generateMore", value: false });
      console.log("error", error);
    }
  };

  const handleSaveWorksheet = async (questionData) => {
    try {
      qnaData.questions = questionData;
      const payload = {
        data: questionData,
        user_id: currentUser?.id,
        role: currentUser?.role,
        draft_status: false,
      };
      setOpenSelectQaOption(false);
      await Promise.allSettled([
        dispatch(setWorksheetView({ selectQnaOpen: false }))
      ]);
      if (currentUser?.role === "teacher") {
        await dispatch(handleCreateWorksheet(qnaData));
        await dispatch(
          setWorksheetView({ open: true, questions: qnaData.questions })
        );
      } else {
        const result = await dispatch(handleSaveQuestionBank(payload));
        if (result?.length > 0) {
          showAlert("Questions saved successfully!", "success");
        } else {
          showAlert("Something went wrong, please try again!", "error");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleClose = (is_open = true) => {
    if (is_open) {
      setIsOpen(false);
    }
    setTitle("");
    setMoods(null);
    setTenses(null);
    setCategories([]);
    setPronouns([]);
    setQuestionType(
      question_type_generate_more_worksheet.map((option) => option.value)
    );
    setQuestionLength(null);
    updatePopUpAtOnce(false);
  };

  const renderFormField = (
    label,
    state,
    setState,
    options,
    mode,
    conditionalRender,
    disabled = false
  ) => {
    const isMultiple = mode === "multiple";
    const isSingle = mode === "single";
    const moodSelected = getLabels(mood, moodsOption)?.toString();

    const modifiedOptions = options.map((option) => {
      const moodSelected = getLabels(mood, moodsOption)?.toString();

      if (disabled) {
        return { ...option, disabled: true };
      }

      if (option.label === "yo" && moodSelected === "Imperative") {
        return { ...option, disabled: true };
      }
      return { ...option, disabled: false };
    });
    const shouldRender = conditionalRender
      ? conditionalRender(label, state)
      : true;

    if (!shouldRender) return null;

    const reorderedOptions = reorderOptions(modifiedOptions, state);
    const handleDropdownVisibleChange = (visible, currentLabel) => {
      setDropdownVisibility((prevVisibility) => ({
        ...prevVisibility,
        [currentLabel]: visible,
      }));
    };

    if (moodSelected === "Imperative" && label === "Tenses") {
      return null;
    }

    if (
      moodSelected === "Imperative" &&
      label === "category" &&
      mood !== null
    ) {
      return null;
    } else if (
      moodSelected !== "Imperative" &&
      label === "category" &&
      mood !== null &&
      tenses !== null
    ) {
      return null;
    }

    return (
      <Col
        sm={24}
        lg={24}
        key={label}
        style={{
          position: "relative",
          marginTop: 15,
          maxWidth:
            label === "Verbs" ? "80%" : label === "Questions:" ? "30%" : "100%",
        }}
      >
        {mode === "multiple" &&
          (dropdownVisibility[label] ? (
            <Close
              style={{
                color: "red",
                fontSize: 24,
                position: "absolute",
                bottom: 12,
                right: 17,
                zIndex: 9,
              }}
            />
          ) : (
            <ArrowDropDown
              style={{
                color: "rgba(0, 0, 0, 0.54)",
                fontSize: 24,
                position: "absolute",
                bottom: 12,
                right: 17,
                zIndex: 9,
              }}
            />
          ))}
        <LinkAreaField>
          <div style={{ display: "flex", gap: "4px", alignItems: "center", position: "absolute", top: "-2px", left: "-2px", maxWidth: "calc(100% + 4px)" }}>
            <LabelAll>{label}</LabelAll>
            {currentUser?.role !== "owe_admin" && (label === "Pronouns" || label === "Question Type") && (
              <ValidationMessageWithTooltip 
                label={label}
                text={label === "Pronouns" 
                  ? "All pronouns have to be selected." 
                  : "All question types have to be selected."}
              />
            )}
          </div>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Select
              suffixIcon={
                mode === "single" ? (
                  dropdownVisibility[label] ? (
                    <Close
                      style={{
                        color: "red",
                        fontSize: 24,
                        zIndex: 9,
                      }}
                    />
                  ) : (
                    <ArrowDropDown
                      style={{
                        color: "rgba(0, 0, 0, 0.54)",
                        fontSize: 24,
                        zIndex: 9,
                      }}
                    />
                  )
                ) : (
                  smileIcon
                )
              }
              showSearch={!isMultiple && !isSingle}
              variant="borderless"
              mode={mode === "multiple" ? "multiple" : undefined}
              style={{ width: "100%" }}
              options={reorderedOptions}
              placeholder={`Select ${label}`}
              maxTagCount="responsive"
              value={state}
              onChange={(selected) =>
                !disabled && setState(mode === "multiple" ? selected : selected)
              }
              open={dropdownVisibility[label]}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              onDropdownVisibleChange={(e) =>
                handleDropdownVisibleChange(e, label)
              }
            />
          </Space>
        </LinkAreaField>
      </Col>
    );
  };

  return (
  <SentryWrap>
    <>
      <GenerateLoader
        open={loader?.type === "generate" && loader?.value === true}
        onClose={() => setLoader({})}
      />
      <SelectQaOption
        loading={loader}
        questionData={qnaData?.questions}
        openModal={openSelectQaOption}
        onCancel={() => setOpenSelectQaOption(false)}
        selectedTypes={selectedTypes}
        setSelectedTypes={setSelectedTypes}
        handleGenerateMoreQnA={handleGenerateMoreQna}
        handleSaveWorksheet={handleSaveWorksheet}
        questionType={questionType}
        questionCount={questionCount}
        questionLengthValue={
          questionLength
            ? NUMBER_OF_QUESTION_OPTION.find((opt) => opt.value === questionLength)?.label
            : ""
        }
      />

      <Modal
        open={isOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ModalContent bgColor={"rgb(39, 117, 148)"}>
          <Row
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              position: "relative",
            }}
          >
            <TitleText></TitleText>
            <TitleText>
              Grammar Drills <RandomImage src={image} alt="Random" />
            <AIUsageInfo />
            </TitleText>
            <TitleText></TitleText>
            <IconButton
              onClick={() => handleClose()}
              style={{ padding: 0, position: "absolute", right: 0, top: 0 }}
            >
              <img style={{ height: 25 }} src={CloseIconss} alt="" title="" />
            </IconButton>
          </Row>
          <ModalAllContant style={{ paddingInline: 15 }}>
            {currentUser?.role !== "owe_admin" && (
              <Col sm={24} lg={24} style={{ marginTop: 15 }}>
                <LinkAreaField>
                  <Label>{"Title"}</Label>
                  <Input
                    style={{
                      height: 33,
                      border: "1px solid",
                      borderRadius: 20,
                    }}
                    placeholder="Enter Title here"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </LinkAreaField>
              </Col>
            )}

            {[
              {
                label: "Mood",
                state: mood,
                // setState: setMoods,
                setState: (selectedMood) => {
                  setMoods(selectedMood);
                  setTenses(null);
                  setCategories([]);
                  if (currentUser?.role !== "owe_admin") {
                    setPronouns(pronounOptions.map((option) => option.value));
                  } else {
                    setPronouns([]);
                  }
                },
                options: moodsOption,
                mode: "single",
              },
              {
                label: "Tenses",
                state: tenses,
                // setState: setTenses,
                setState: (selectedTense) => {
                  setTenses(selectedTense);
                  setCategories([]);
                  if (currentUser?.role !== "owe_admin") {
                    setPronouns(pronounOptions.map((option) => option.value));
                  } else {
                    setPronouns([]);
                  }
                },
                options: getTenseOptionData,
                mode: "single",
                conditionalRender: (label) =>
                  mood !== null || mood !== "Imperative",
              },
              {
                label: "Categories",
                state: categories,
                setState: setCategories,
                options: getCategoryOption,
                mode: "multiple",
                conditionalRender: (label) => mood !== null,
              },
              {
                label: "Pronouns",
                state: pronouns,
                setState: setPronouns,
                options: pronounOptions,
                mode: "multiple",
                disabled: currentUser?.role !== "owe_admin",
              },
              {
                label: "Question Type",
                state: questionType,
                setState: setQuestionType,
                options: question_type_generate_more_worksheet,
                mode: "multiple",
                disabled: currentUser?.role !== "owe_admin",
              },
              {
                label: "Questions:",
                state: questionLength,
                setState: setQuestionLength,
                options: NUMBER_OF_QUESTION_OPTION,
                mode: "single",
              },
            ].map(
              ({ label, state, setState, options, mode, conditionalRender, disabled }) =>
                renderFormField(
                  label,
                  state,
                  setState,
                  options,
                  mode,
                  conditionalRender,
                  disabled
                )
            )}

            <div style={{ marginTop: 20 }}>
              <ButtonContainer>
                <ContinueButton
                  onClick={handleGenerate}
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  {creeateLoader && <Loading size={18} white />}
                  {currentUser?.role !== "owe_admin"
                    ? "Create Practice"
                    : "Generate Questions"}
                </ContinueButton>
              </ButtonContainer>
            </div>
          </ModalAllContant>
        </ModalContent>
      </Modal>
    </>
  </SentryWrap>
  );
}

const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 543px;
  padding: 20px;
  position: absolute;
  min-height: 250px;
  // max-height: 95vh;
  // overflow-x: hidden;
  border-radius: 25px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: ${(p) => p.bgColor || "#fff"};
  @media only screen and (max-width: 600px) {
    min-width: 90%;
  }
`;

const ModalAllContant = styled.div`
  overflow-y: auto;
  max-height: 75vh;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  @media only screen and (max-width: 600px) {
    min-width: 90%;
  }
`;

// const ModalContent = styled.div`

// `;

const TitleText = styled.span`
  font-size: 28px;
  font-weight: 500;
  color: white;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
`;

const LinkAreaField = styled.div`
  border-radius: 20px;
  padding: 8px;
  background: #f0f8ff;
  position: relative;
  padding-top: 35px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 12px 24px rgba(0, 0, 0, 0.2);
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 20px;
  }
  .ant-select-selection-overflow {
    z-index: 99;
    cursor: pointer;
  }
`;

const Label = styled.div`
  font-size: 14px;
  color: white;
  font-weight: 500;
  margin-bottom: 5px;
  background: #00d54f;
  width: fit-content;
  padding: 2px 7px;
  border-radius: 6px;
  position: absolute;
  left: -2px;
  top: -2px;
`;

const LabelAll = styled.div`
  font-size: 14px;
  color: white;
  font-weight: 500;
  margin-bottom: 5px;
  background: #00d54f;
  width: fit-content;
  padding: 2px 7px;
  border-radius: 6px;
`;

const ValidationMessage = styled.div`
  font-size: 12px;
  color: black;
  font-weight: 400;
  display: block;
  margin-left: 0px;
  cursor: pointer;
  min-width: 0;
  flex-shrink: 1;

  @media only screen and (min-width: 601px) {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  }

  @media only screen and (max-width: 600px) {
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const ContinueButton = styled.button`
  background-color: rgb(0, 15, 76);
  color: white;
  font-size: 16px;
  font-weight: bold;
  padding: 6px 14px;
  border-radius: 25px;
  border: none;
  cursor: pointer;
  text-align: center;
  outline: none;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: #34495e;
    // transform: scale(1.05);
  }

  &:focus {
    outline: none;
  }
`;
const RandomImage = styled.img`
  height: 90px;
  border-radius: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 20px;
  justify-content: flex-end;
  @media only screen and (max-width: 600px) {
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding-bottom: 20px;
  }
  @media only screen and (min-width: 601px) and (max-width: 768px) {
    padding-bottom: 20px;
  }
`;
